import React from "react";
import { Phone, MapPin, Clock, Mail } from "lucide-react";
import { Logo } from "./Logo";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="relative bg-[#070707] border-t border-white/10 pt-16 pb-8" data-testid="site-footer">
      <div className="hazard-stripes h-1.5 w-full absolute top-0 left-0" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-12 gap-10 pb-10 border-b border-white/5">
          <div className="md:col-span-5">
            <Logo />
            <p className="mt-5 text-neutral-400 text-sm leading-relaxed max-w-md">
              Service de remorquage, dépannage et entretien automobile à Perpignan.
              Disponible 24h/24, 7j/7. Brave, sérieux, à votre service.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="font-display text-sm uppercase tracking-[0.25em] text-[#FFD600] mb-4">Services</div>
            <ul className="space-y-2 text-sm text-neutral-400">
              <li>Remorquage</li>
              <li>Dépannage</li>
              <li>Gardiennage</li>
              <li>Petit entretien</li>
              <li>Nettoyage auto</li>
              <li>Récupération VHU</li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="font-display text-sm uppercase tracking-[0.25em] text-[#FFD600] mb-4">Contact</div>
            <ul className="space-y-3 text-sm text-neutral-300">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-[#FFD600] mt-0.5" />
                <a href="tel:+33620735220" data-testid="footer-phone" className="hover:text-[#FFD600] transition-colors">
                  06 20 73 52 20
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#FFD600] mt-0.5" />
                <span>2670 avenue Julien Panchot, 66000 Perpignan</span>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="w-4 h-4 text-[#FFD600] mt-0.5" />
                <span>24h/24 · 7j/7</span>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-[#FFD600] mt-0.5" />
                <a href="mailto:mkremorquage66@gmail.com" className="hover:text-[#FFD600] transition-colors">
                  mkremorquage66@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-neutral-500">
          <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span>© {year} MK Remorquage — Tous droits réservés</span>
            <a href="/mentions-legales" data-testid="footer-legal-link" className="hover:text-[#FFD600] uppercase tracking-wider">
              Mentions légales & RGPD
            </a>
          </div>
          <div className="flex items-center gap-2">
            <span className="h-2 w-2 rounded-full bg-emerald-500 pulse-dot" />
            <span className="uppercase tracking-[0.25em]">En service maintenant</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
